import HeaderRightControls from './controls/right/HeaderRightControls';
import styles from './editorHeader.module.scss'

// import logo from '../../../assets/editor_logo.svg';
import React, {useEffect, useState} from "react";
import EnvMode from "../../../com/envManager/EnvMode";
import {
    EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE,
    addEventDataTypeListener,
    removeEventTypeListener,
    EVENT_DATA_TYPE_CREAT_NEW_FLYER,
    dispatchEventDataType,
    EVENT_DATA_TYPE_DISABLE_TABS,
    EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP
} from '../../../globals/EventDispatcher'
import {CustomDataEvent} from "../../../globals/CustomDataEvent";
// import {ReactComponent as InfoIcon} from "../../../assets/editors/info_icon.svg";
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import {getSettingsForPopup} from "../pages/getSetttingsForPopup";
import StatusPopup from "../../../com/statusPopup/StatusPopup";
import {Box, Button, Grid, Typography, useMediaQuery} from "@mui/material";
import {makeStyles} from "@mui/styles";
import envManager from "../../../com/envManager/EnvManager";
import {useDispatch} from "react-redux";
import {getFlippingFlyer, updateFlyersState} from "../../../store/actionCreators/flippingFlyerActionCreators";
import {SelectPageForTabsDto, UploadProgressingImagesDto, UserDto} from "../../../dtos";
import {HttpTransportType, HubConnectionBuilder, IHttpConnectionOptions, LogLevel} from "@microsoft/signalr";
import {changeUploadingImagesProgressPopup} from "../../../store/actionCreators/uploadingImagesProgressActionCreator";
import {updateFlyerDetailsPageImageState} from "../../../store/actionCreators/flyerDetailsActionCreators";
import {CreateFlyerModal} from "../createFlyerModal/createFlyerModal";
import {getFlyers} from "../../../store";

const useStyles = makeStyles(() => ({
    editorHeader: {
        height: `50px`,
        background: `linear-gradient(90deg, #0099D2 0%, #353FA8 100%)`,
    },
    headerBox: {
        height: `100%`,
        display: `flex`,
        alignItems: `center`,
        '&.editorLogo': {
            // height: `29px`,
            alignItems: `flex-start`,
            padding: `0 20px`
        }
    },
    openFlyerBtn: {
        '&.Mui-disabled': {
            opacity: `0.5`
        }
    },
    openFlyerDetailsPopup: {
        '&.Mui-disabled': {
            opacity: `0.5`
        }
    }
}))

export const EditorHeader: React.FC = () => {
    const dispatch = useDispatch();
    const [title, setTitle] = useState('');
    const [isShow, show] = useState(false);
    const [isNew, createNew] = useState(false);
    const [isInfoPopupOpen, setInfoPopupStatus] = useState<boolean>(false);
    const [url, setUrl] = useState<string>("--");
    const [isDisabledOpen, setDisabledOpen] = useState<boolean>(false);
    const [isDisabledFlyerDetailPopup, setDisabledFlyerDetailPopup] = useState<boolean>(false);
    const classes = useStyles();
    // let changedStateForFlyer = useTypedSelector((state) => state.changedStateForFlyer);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const flyersState = useTypedSelector((state) => state.flyers);
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    //signalR start
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isXs = useMediaQuery(`(max-width:699px)`);

    const [connection, setConnection] = useState<any>(null);

    const optionsSignal: IHttpConnectionOptions = {
        accessTokenFactory: () => {
            return userDto.token;
        },
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
    };

    useEffect(() => {
        if (connection) {
            connection.keepAliveIntervalInMilliseconds = 1000 * 60 * 3;
            connection.serverTimeoutInMilliseconds = 1000 * 60 * 6;
            connection.start().catch((e: any) => {
                console.log('Connection failed: ', e)
            });
            connection.on('ReceiveResponse', (message: any) => {
                const data: UploadProgressingImagesDto = {
                    isOpen: true,
                    isUploadingFilesToSystem: false,
                    isUploadingFilesToSystemFinished: true,
                    current: message.current,
                    failCount: message.failCount,
                    processingFinished: message.processingFinished,
                    successCount: message.successCount,
                    total: message.total,
                    severityLevel: message.response.severityLevel,
                    titlePopup: message.response.title === "Image Upload Started" ? message.response.title : message.response.userFriendlyMessage,
                    notUploadedImages: message.response.severityLevel.toString().toLowerCase() === 'error' ? [{
                        imageFileName: message.response.data[0].value,
                        message: message.response.userFriendlyMessage
                    }] : null,
                }
                dispatch(changeUploadingImagesProgressPopup(data))
                console.log(`signalR response "ReceiveResponse event":`);
                console.log(message);
            });
            connection.on('UploadPageImagesResponse', (message: any) => {
                const data: UploadProgressingImagesDto = {
                    isOpen: true,
                    isUploadingFilesToSystem: false,
                    isUploadingFilesToSystemFinished: true,
                    current: message.current,
                    failCount: message.failCount,
                    processingFinished: message.processingFinished,
                    successCount: message.successCount,
                    total: message.total,
                    severityLevel: message.response.severityLevel,
                    titlePopup: message.response.title === "Image Upload Started" ? message.response.title : message.response.userFriendlyMessage,
                    notUploadedImages: message.response.severityLevel.toString().toLowerCase() === 'error' ? [{
                        imageFileName: message.response.data[0].value,
                        message: message.response.userFriendlyMessage
                    }] : null,
                }
                dispatch(changeUploadingImagesProgressPopup(data))
                dispatch(updateFlyerDetailsPageImageState({
                    pageId: message.data?.pageId,
                    imageUrl: message.data?.imageUrl,
                    imageThumbnailUrl: message.data?.thumbnailUrl
                }))
                console.log(`signalR response "UploadPageImagesResponse event":`);
                console.log(message);
                const tabIndex = getActiveTabIndex();
                if (tabIndex === 0 && message.processingFinished && message.total !== 0) {
                    dispatch(getFlyers(false, false));
                }
            });
        }
    }, [connection]);

    //signalR end


    useEffect(() => {
        if (flippingFlyerState.type !== 'GET_FLIPPING_FLYER_ERROR') {
            setDisabledOpen(flippingFlyerState.loading);
            setDisabledFlyerDetailPopup(flippingFlyerState.loading);
        }
    }, [flippingFlyerState.type])

    useEffect(() => {
        if (title !== '') {
            try {
                let currentFlyerStatus = flyerDetailsState.flyFstRec;
                let statusCaption = currentFlyerStatus.fstCaption?.toLowerCase()

                let appUrl = '';

                if (statusCaption?.includes('edit')) {
                    appUrl = envManager.getFlyerAppAddressWithEnvPrefix('dev')
                } else if (statusCaption?.includes('qa')) {
                    appUrl = envManager.getFlyerAppAddressWithEnvPrefix('qa')
                } else if (statusCaption?.includes('published')) {
                    appUrl = envManager.getFlyerAppAddressWithEnvPrefix('')
                }

                //
                if (appUrl.length !== 0 && flyerDetailsState.flyRecId) {
                    let accountName = flyerDetailsState.flyAccRec?.accCaption;
                    let flyerName = flyerDetailsState.flyCaption;
                    appUrl += `${flyerDetailsState.flyFltRec?.fltCode === 1 ? "flipbook" : "flyer"}/${accountName}/${flyerName}`
                }

                if (statusCaption?.includes('inactive')) {
                    appUrl = '--'
                }

                // Any way if the current flyer has no job code (RecId) => no flyer app address to show
                if (!flyerDetailsState.flyRecId) {
                    appUrl = '--'
                }
                setUrl(appUrl);
                // if (flyerDetailsState.flyFstRec.fstCaption === "Published" && flyerDetailsState.qualificationLevel === 0) {
                //     setDisabledOpen(true);
                // }
            } catch (e) {
                console.log(e);
            }
        } else {
            setUrl("--")
        }

    }, [flyerDetailsState.flyFstRec, flyerDetailsState.flyRecId])

    useEffect(() => {
        //signalR start
        if (connection === null) {
            const newConnection = new HubConnectionBuilder()
                .withUrl(`${envManager.flyerEditorServerAddress}/xceditor-hub`, optionsSignal)
                .configureLogging(LogLevel.Information)
                .withAutomaticReconnect()
                .build();
            setConnection(newConnection);
        }
        //signalR end

        addEventDataTypeListener(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, (data: CustomDataEvent) => {
            setTitle(data.data);
        })
        addEventDataTypeListener(EVENT_DATA_TYPE_CREAT_NEW_FLYER, (data: CustomDataEvent) => {
            createNew(data.data);
            if (data.data) {
                show(true);
            }
        })

        addEventDataTypeListener(EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP, (data: CustomDataEvent) => {
            if (!data.data.isOpen && data.data.isChangedData) {
                console.log("change status for right panel");
                setInfoPopupStatus(true);
                return;
            } else {
                show(data.data.isOpen);
            }
            // dispatch(toggleFlyerDetailsPopup(data.data.isOpen));


        })


        return () => {
            removeEventTypeListener(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE);
            removeEventTypeListener(EVENT_DATA_TYPE_CREAT_NEW_FLYER);
            removeEventTypeListener(EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP);
        }
    }, [])


    const onShowPopup = (isShow: boolean) => {
        dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP, {
            isOpen: isShow,
            isChangedData: false
        });
        // dispatch(toggleFlyerDetailsPopup(false));
        if (isNew && !isShow) {
            dispatch(updateFlyersState(flyersState));
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
        }
        if (!isNew && flyerDetailsState.flyRecId !== 0 && !isShow) {
            dispatch(getFlippingFlyer(flyerDetailsState.flyRecId));
        }
    }

    const getActiveTabIndex = (): number => {
        if (selectedPageState.selectedTabNum) {
            return selectedPageState.selectedTabNum;
        } else {
            return 0
        }
    }

    const openFlyer = () => {
        window.open(url, 'urlFromMainScreen');
    }

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: 'saveBeforeCloseInfo',
    };

    let settingsForPopup = getSettingsForPopup(settings);


    return (
        <Grid container className={classes.editorHeader} alignItems={`center`}>
            <Grid item xs={isXs ? 3 : 6}>
                <Grid container>
                    <Grid item xs={12}>
                        <Box className={`${classes.headerBox} editorLogo`} sx={{
                            display: "flex",
                            flexFlow: "row",
                            columnGap: "12px"
                        }}>
                            <Typography fontSize={`22px`} fontWeight={900} color={`#ffffff`}>
                                {isXs ? "XC" : "xCircular"}
                            </Typography>
                            {
                                !isXs && title !== '' &&
                                <>
                                    <Typography fontSize={`22px`} fontWeight={900} color={`#ffffff`} noWrap>
                                        {title !== '' ? `Flyer - ${title}` : ''}
                                    </Typography>
                                    <Box className={classes.headerBox}>
                                        <Button
                                            disabled={isDisabledOpen}
                                            sx={{
                                                // mx: `15px`,
                                                p: `4px 16px`,
                                                border: `1px solid #FFFFFF`,
                                                textTransform: `capitalize`,
                                                background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
                                                "&:hover": {
                                                    opacity: "0.9"
                                                }
                                            }}
                                            onClick={openFlyer}
                                            className={`${isShow ? styles.is_active : ''} ${classes.openFlyerBtn}`}
                                        >
                                            <Typography color={`#ffffff`}>
                                                Open
                                            </Typography>
                                        </Button>
                                    </Box>
                                </>
                            }
                        </Box>
                    </Grid>

                    {/*
                    <Grid item>
                        <Box className={classes.headerBox}
                             sx={{overflow: "hidden", textOverflow: "ellipsis", maxWidth: '100%'}}>
                            <Typography fontSize={`22px`} fontWeight={900} color={`#ffffff`} noWrap>
                                Flyer Editor{title !== '' ? ` - ${title}` : ''}
                            </Typography>
                        </Box>
                    </Grid>
*/}


                    {/*
                    {
                        title !== '' &&
                        <>
                            <Grid item>
                                <Box className={classes.headerBox}>
                                    <Button
                                        sx={{px: `10px`}}
                                        disabled={isDisabledFlyerDetailPopup}
                                        onClick={() => {
                                            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_OPEN_FLYER_INFO_POPUP, {
                                                isOpen: true,
                                                isChangedData: changedStateForFlyer.isChangedFlyerData
                                            });
                                        }}
                                        className={`${isShow ? styles.is_active : ''} ${classes.openFlyerDetailsPopup}`}>
                                        <InfoIcon/>
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box className={classes.headerBox}>
                                    <Button
                                        disabled={isDisabledOpen}
                                        sx={{
                                            mx: `15px`,
                                            px: `15px`,
                                            border: `1px solid #FFFFFF`,
                                            textTransform: `capitalize`,
                                            background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
                                        }}
                                        onClick={openFlyer}
                                        className={`${isShow ? styles.is_active : ''} ${classes.openFlyerBtn}`}
                                    >
                                        <Typography color={`#ffffff`}>
                                            Open
                                        </Typography>
                                    </Button>
                                </Box>
                            </Grid>
                        </>
                    }
*/}

                </Grid>
            </Grid>
            {
                !isXs &&
                <Grid item>
                    <Box className={classes.headerBox} justifyContent={"center"}>
                        <EnvMode/>
                    </Box>
                </Grid>
            }
            {
                isXs &&
                <Grid item xs>
                    <Box className={classes.headerBox} justifyContent={"center"}>
                        <Typography fontWeight={700} fontSize={"22px"} textAlign={"center"} color={"#ffffff"} noWrap>
                            Flyers Editor
                        </Typography>
                    </Box>
                </Grid>
            }
            <Grid item xs={isXs ? 3 : true}>
                <HeaderRightControls/>
            </Grid>
            <CreateFlyerModal/>
            {/*{*/}
            {/*    isShow && <FlyerDetailsPopup*/}
            {/*        show={onShowPopup}*/}
            {/*        isNew={isNew}*/}
            {/*        createNew={createNew}*/}
            {/*        isShow={isShow}*/}
            {/*    />*/}
            {/*}*/}

            {
                isInfoPopupOpen && <StatusPopup
                    settings={settingsForPopup}
                    type={settingsForPopup.typeStatus || 0}
                    title={settingsForPopup.title || ''}
                    subTitle={''}
                    messages={[settingsForPopup.messages]}
                    show={isInfoPopupOpen}
                    handleClose={() => setInfoPopupStatus(false)}
                />
            }

        </Grid>
    )
}
